import React from 'react';
import ReactEcharts from 'echarts-for-react';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import * as echarts from 'echarts';

interface ILineChart {
    xAxisData: Array<string | number>;
    completedData?: Array<number>;
    progressData?: Array<number>;
    failedData?: Array<number>;
    manualData?: Array<number>;
}

// Helper function to normalize data (ensures all datasets have the same length as xAxisData)
const normalizeData = (data: Array<number> | undefined, length: number) => {
    return data && data.length === length ? data : new Array(length).fill(0);
};

const LineChart = ({ xAxisData, completedData, progressData, failedData, manualData }: ILineChart) => {
    // Normalize data to ensure all arrays match xAxisData length
    const normalizedCompleted = normalizeData(completedData, xAxisData.length);
    const normalizedProgress = normalizeData(progressData, xAxisData.length);
    const normalizedFailed = normalizeData(failedData, xAxisData.length);
    const normalizedManual = normalizeData(manualData, xAxisData.length);

    const getOptionBar = () => ({
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'cross', label: { backgroundColor: '#6a7985' } }
        },
        legend: {
            data: ['Success', 'In Progress', 'Failed', 'Manual Review'],
            bottom: '2%',
            left: 'center',
            icon: 'circle',
            itemGap: 20,
        },
        grid: { left: '3%', right: '4%', bottom: '15%', containLabel: true },
        xAxis: [
            {
                type: 'category',
                boundaryGap: false,
                data: xAxisData,
                splitLine: { lineStyle: { type: 'dashed', dashOffset: 5 } },
                axisLine: { show: false, lineStyle: { type: 'dashed' } },
                axisTick: { show: false, lineStyle: { color: 'transparent' } },
                minorTick: { show: false }
            }
        ],
        yAxis: [
            {
                type: 'value',
                min: 0,
                max: 'dataMax',
                splitLine: { lineStyle: { type: 'dashed', dashOffset: 1, width: 1.4 } },
                axisTick: { show: false, lineStyle: { color: 'transparent' } },
                minorTick: { show: false },
                axisLine: { show: false }
            }
        ],
        series: [
            {
                name: 'Success',
                type: 'line',
                smooth: true,
                lineStyle: { width: 2, color: "#008000" },
                showSymbol: false,
                itemStyle: { color: "#008000" },
                emphasis: { focus: 'series', symbol: 'circle', symbolSize: 7, itemStyle: { borderColor: "#008000", color: "#FFF", borderWidth: 2 } },
                data: normalizedCompleted
            },
            {
                name: 'In Progress',
                type: 'line',
                smooth: true,
                lineStyle: { width: 2, color: "#007AFF" },
                showSymbol: false,
                itemStyle: { color: "#007AFF" },
                emphasis: { focus: 'series', symbol: 'circle', symbolSize: 7, itemStyle: { borderColor: "#007AFF", color: "#FFF", borderWidth: 2 } },
                data: normalizedProgress
            },
            {
                name: 'Failed',
                type: 'line',
                smooth: true,
                lineStyle: { width: 2, color: "#FF0000" },
                showSymbol: false,
                itemStyle: { color: "#FF0000" },  // <-- Set legend color
                emphasis: { focus: 'series', symbol: 'circle', symbolSize: 7, itemStyle: { borderColor: "#FF0000", color: "#FFF", borderWidth: 2 } },
                data: normalizedFailed
            },
            {
                name: 'Manual Review',
                type: 'line',
                smooth: true,
                lineStyle: { width: 2, color: "#553B02" },
                showSymbol: false,
                itemStyle: { color: "#553B02" },  // <-- Set legend color
                emphasis: { focus: 'series', symbol: 'circle', symbolSize: 7, itemStyle: { borderColor: "#553B02", color: "#FFF", borderWidth: 2 } },
                data: normalizedManual
            }
        ]
    });
    

    return (
        <div>
            <ReactEcharts option={getOptionBar()} style={{ height: 400, width: '100%' }} />
        </div>
    );
};

export default LineChart;
